<template>
  <v-app>
    <!-- Header -->
    <Header></Header>

    <!-- Footer -->
    <Footer></Footer>
  </v-app>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  data: () => ({}),
  props: {
    source: String
  }
};
</script>
